// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-module__simpleTable__eJ2Pr{margin-bottom:0 !important}.index-module__simpleTable__eJ2Pr th{font-family:'Gotham Medium';border-top:0 !important}.index-module__simpleTable__eJ2Pr td{white-space:nowrap}.index-module__simpleTable__eJ2Pr th,.index-module__simpleTable__eJ2Pr td{padding:0.25rem !important}\n", ""]);
// Exports
exports.locals = {
	"simpleTable": "index-module__simpleTable__eJ2Pr"
};
module.exports = exports;
